<script setup lang="ts">
import type { SmallBanner } from '@shared/types/models'
import linkTo from '@shared/modules/linkTo'

type Props = {
    banner: SmallBanner
}

const { banner } = defineProps<Props>()
</script>

<template>
    <a
        v-if="banner.product"
        :href="linkTo(`/product/${banner.product.slug}`)"
        class="relative inline-block shadow-md transition-shadow hover:shadow-lg group overflow-hidden rounded-md"
    >
        <img
            :src="`/storage/small-banners/${banner.category_slug}.webp`"
            :title="banner.title"
            alt="Slide"
            class="w-full h-full object-cover object-center rounded-md group-hover:scale-110 transition-transform duration-500"
            width="370"
            height="250"
        />

        <div class="absolute left-5 top-1/2 -translate-y-1/2 w-[170px]">
            <span class="text-sm lg:text-lg !leading-3 text-gray-600" data-label="Product description">
                {{ banner.title }}
            </span>

            <b class="text-lg lg:text-xl font-bold block" data-label="Product title">
                {{ banner.brand }}
            </b>

            <span
                data-label="Product price"
                class="font-black text-main-pink flex items-center"
            >
                <span class="text-xl lg:text-2xl">{{ banner.product.price }}</span>
                <span class="text-lg ml-1">{{ $trans.get('common.uah') }}</span>
            </span>
        </div>
    </a>
</template>
